"use client";

import { useLocale } from "@/lib/locale-context";
/**
 * Бейдж города поверх фото машины. Филиал НЕ показываем (решение: на Автопилоте
 * только город; «Основной офис» из 1С — тем более шум). size="sm" — половинный
 * размер для мини-карточек (альтернативы на стр. машины, тема — правая колонка).
 */
export default function CityOfficeBadge({
  city,
  filial,
  size = "md",
  className = "",
}: {
  city?: string;
  filial?: string;
  size?: "md" | "sm";
  className?: string;
}) {
  const { locale } = useLocale();
  if (!city && !filial) return null;
  const sm = size === "sm";
  const box = sm ? "rounded-lg px-1.5 py-0.5" : "rounded-xl px-2.5 py-1.5";
  const cityText = sm ? "text-[10px] gap-0.5" : "text-[13px] gap-1";
  const icon = sm ? 9 : 12;
  const filText = sm ? "text-[8px] pl-[11px] mt-0" : "text-[11px] pl-[16px] mt-0.5";
  return (
    <span className={`inline-flex flex-col bg-primary/95 text-white shadow-[0_2px_8px_rgba(0,57,166,0.35)] backdrop-blur-sm ${box} ${className}`}>
      {city ? (
        <span className={`flex items-center whitespace-nowrap font-bold leading-[1.2] ${cityText}`}>
          <svg width={icon} height={icon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden className="shrink-0">
            <path d="M21 10c0 6-9 12-9 12s-9-6-9-12a9 9 0 0 1 18 0Z" />
            <circle cx="12" cy="10" r="3" />
          </svg>
          {city}
        </span>
      ) : null}
      {/* филиал скрыт: на карточках Автопилота показываем только город */}
    </span>
  );
}
